export const SET_FILTER = "SET_FILTER";
export const SET_NAME = "SET_NAME";
export const SET_DATE = "SET_DATE";
export const SET_STATUS = "SET_STATUS";
export const SET_ALL = "SET_ALL";
